<script setup lang="ts">
import { useI18n } from "vue-i18n"

import { ABOUT } from "@/pages"

const { t } = useI18n({ useScope: "global" })
</script>

<template>
  <RouterLink id="aboutlink-link-about" :to="{ name: 'DocumentGet', params: { id: ABOUT } }" class="link" :title="t('footer.about')">{{
    t("footer.aboutShort")
  }}</RouterLink>
</template>
